// Shared app state that both auth.js and the main script need to read AND write.
// ES modules export "live bindings" — every importer sees updates automatically
// when setCurrentUser() runs, without any of them needing to poll or re-import.
export let currentUser = null; // set by checkAuth() on load, and by every login/signup/logout flow
export function setCurrentUser(user) { currentUser = user; }
